import apiClient from './apiClient';

export const dashboardService = {
  // Endpoints existants
  getStats: () => 
    apiClient.get('/dashboard/stats'),

  getStatsForPeriod: (startDate: string, endDate: string) =>
    apiClient.get(`/dashboard/stats/period?start=${startDate}&end=${endDate}`),

  getSubscriptionsByCountry: () =>
    apiClient.get('/dashboard/subscriptions/by-country'),

  getRevenueStats: () =>
    apiClient.get('/dashboard/revenue'),

  getEsimActivationStats: () =>
    apiClient.get('/dashboard/esim/stats'),

  // Nouveaux endpoints de la section statistics-resource
  getSubscribersCount: () =>
    apiClient.get('/statistics/subscribers'),

  getEsimAvailable: () =>
    apiClient.get('/statistics/esim/available'),

  getEsimActif: () =>
    apiClient.get('/statistics/esim/actif'),

  getAgencyUnusedBalance: () =>
    apiClient.get('/statistics/agency/unused-balance'),

  getAgencyTurnover: (startDate: string | undefined, endDate: string | undefined) =>
    apiClient.post(`/statistics/agency/turnover?fromDate=${startDate??'01-01-2000'}&toDate=${endDate??'01-01-2050'}`,{"fromDate": startDate??"1971-01-01T00:00:00Z",
    "toDate": endDate??"2050-01-01T23:59:59Z"}),

  getAgenciesCount: () =>
    apiClient.get('/statistics/agencies')
};